import React from "react";

import { formatNumber, trimToDecimals, useTranslation } from "utils";

import { FootprintCalculationSummary } from "models";

import { Card, Flex, Icon, OutlinedCard, Tooltip } from "components";

interface SummaryTilesProps {
  footprintCalculationSummary?: FootprintCalculationSummary;
  hidePerYield?: boolean;
  farmId?: string;
}

export const SummaryTiles: React.FC<SummaryTilesProps> = ({ footprintCalculationSummary, hidePerYield = false }) => {
  const { t } = useTranslation("footprinting");

  return (
    <Card className="container large summary-card-wrapper">
      <Flex className="gap-16" justify="space-between" gap={16}>
        <OutlinedCard dataTestId="crop-summary-tile" className="width-100">
          <Flex vertical align="center">
            <h1>{footprintCalculationSummary ? formatNumber({ number: trimToDecimals(footprintCalculationSummary.overall.totalCO2e) }) : "N/A"} kg</h1>
            <Tooltip title={t("resultsPage.summaryTiles.co2eInTotal")}>
              <Flex align="center" gap={4} className="padding-top-25">
                <span className="paragraph-s grey-600-text">{t("resultsPage.summaryTiles.co2eInTotal")}</span>
                <Icon size="s" iconName="tabler/info-circle" stroke="#999" />
              </Flex>
            </Tooltip>
          </Flex>
        </OutlinedCard>

        {hidePerYield ? null : (
          <OutlinedCard dataTestId="crop-summary-tile" className="width-100">
            <Flex vertical align="center">
              <h1>{footprintCalculationSummary ? formatNumber({ number: trimToDecimals(footprintCalculationSummary.overall.perKgYieldCO2e) }) : "N/A"} kg</h1>
              <Tooltip title={t("resultsPage.summaryTiles.co2ePerKgYield")}>
                <Flex align="center" gap={4} className="padding-top-25">
                  <span className="paragraph-s grey-600-text">{t("resultsPage.summaryTiles.co2ePerKgYield")}</span>
                  <Icon size="s" iconName="tabler/info-circle" stroke="#999" />
                </Flex>
              </Tooltip>
            </Flex>
          </OutlinedCard>
        )}

        <OutlinedCard dataTestId="crop-summary-tile" className="width-100">
          <Flex vertical align="center">
            <h1>{footprintCalculationSummary ? formatNumber({ number: trimToDecimals(footprintCalculationSummary.overall.perHaCO2e) }) : "N/A"} kg</h1>
            <Tooltip title={t("resultsPage.summaryTiles.co2ePerHa")}>
              <Flex align="center" gap={4} className="padding-top-25">
                <span className="paragraph-s grey-600-text">{t("resultsPage.summaryTiles.co2ePerHa")}</span>
                <Icon size="s" iconName="tabler/info-circle" stroke="#999" />
              </Flex>
            </Tooltip>
          </Flex>
        </OutlinedCard>
      </Flex>
    </Card>
  );
};
